import { render, staticRenderFns } from "./TabTrain.vue?vue&type=template&id=37e0ed47&scoped=true&"
import script from "./TabTrain.vue?vue&type=script&lang=js&"
export * from "./TabTrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0ed47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37e0ed47')) {
      api.createRecord('37e0ed47', component.options)
    } else {
      api.reload('37e0ed47', component.options)
    }
    module.hot.accept("./TabTrain.vue?vue&type=template&id=37e0ed47&scoped=true&", function () {
      api.rerender('37e0ed47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/tabItem/TabTrain.vue"
export default component.exports